export const texts = {
  fr: {
    seo_title: "Téléchargements : documentations techniques - FEHR Group",
    seo_description:
      "Brochure, catalogue, avis technique : trouvez toutes les documentations associées à un système ou à un produit FEHR",
  },
}
